import React, { useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Section from './Section';
import SectionV2 from './Section/v2';
import { ObjModal } from '../../../contexts';
import { Timeline, TimelineEvent } from 'react-event-timeline';
import EmailIcon from '@mui/icons-material/Email';
import TextsmsIcon from '@mui/icons-material/Textsms';
import CallIcon from '@mui/icons-material/Call';
import TimelineEmail from './Timeline/Email';
import TimelineSms from './Timeline/Txt';


const Details = ( { aid, layout, commsLoaded } ) => {
    const [ view, setView ] = useState( [] );
    const [ v2, setV2 ] = useState( false );
    const { obj, objType } = useContext( ObjModal );
    
    const formatDate = ( d ) => {
        const dd = new Date( d );
        return dd.toLocaleString();
    };

    const getCommIcon = ( t ) => {
        let icon;

        switch ( t ) {
            case 'call':
                icon = <CallIcon />;
                break;

            case 'sms':
                icon = <TextsmsIcon />;
                break;

            case 'email':
                icon = <EmailIcon />;
                break;

            default:
                console.log( 'unknown comm icon type: ' + t );
        }

        return icon;
    };

    useEffect( () => {
        if ( layout && obj.details ) {
            if ( layout.v2 ) {
                // console.log( 'setting v2 layout', layout.v2.sections );
                setV2( true );
                setView( layout.v2.sections );
            } else if ( layout.key && layout[obj.details[layout.key]] ) {
                setView( layout[obj.details[layout.key]] );
            } else {
                setView( layout.default );
            }
        }
    }, [ layout, obj.details ] );

    useEffect( () => {
        if ( obj.comms && obj.comms.length ) {
            console.log( 'sorting: ', obj.comms );
        }
        obj?.comms?.sort( ( a, b ) => {
            let ad = Date.parse( a.commDate );
            let bd = Date.parse( b.commDate );

            if ( !ad ) {
                ad = Date.parse( a.createdDate );
            }
            if ( !bd ) {
                bd = Date.parse( b.createdDate );
            }
            return bd - ad;
        } );
        // console.log( obj.comms );
    }, [ obj.comms ] );

    return (
        <Container fluid className='p-0'>
            {
                ( objType === 'contact' ) ? (
                    <Tabs defaultActiveKey="details" id="tf-contact-details" className="m-0">
                        <Tab eventKey="details" title="Main Details">
                            {
                                ( v2 ) ? (
                                    view.map( ( v, idx ) => {
                                        let show = true;
                                        if ( v.conditional ) {
                                            console.log( 'cond: ', v.conditional );
                                            switch ( v.conditional.operator ) {
                                                case 'valid':
                                                    console.log( obj.details[v.conditional.db] );
                                                    show = ( obj.details[v.conditional.db] !== undefined );
                                                    break;

                                                case 'logic':
                                                    console.log( 'evaluating: ', v.conditional.logic );
                                                    show = eval( v.conditional.logic );
                                                    break;

                                                default:
                                                    show = ( obj.details[v.conditional.db] === v.conditional.value );
                                            }
                                        }
                                        if ( show ) {
                                            return <SectionV2 key={`section-${idx}`} title={v.title} body={v.body} id={v.id ??  'gen'} />;
                                        }
                                        return null;
                                    } )
                                ) : (
                                    view.map( ( v, idx ) => {
                                        if ( !v.conditional || obj.details[v.conditional.db] === v.conditional.value ) {
                                            return <Section key={`section-${idx}`} title={v.title} body={v.body} id={v.id ?? 'gen'} />;
                                        }
                                        return null;
                                    } )
                                )
                            }
                        </Tab>
                        <Tab eventKey="comms" title="Comms">
                            <Timeline lineColor='var( --tf-blue )'>
                                {
                                    obj?.comms?.map( c => (
                                        <TimelineEvent
                                            key={c.cid}
                                            title={c.name ?? ''}
                                            createdAt={ formatDate( c.commDate ? c.commDate : c.createdDate ) }
                                            icon={ getCommIcon( c.commType ) }
                                            iconStyle={ { color: 'var( --tf-orange )' } }
                                            bubbleStyle={ { borderColor: 'var( --tf-orange )' } }
                                        >
                                            {
                                                ( c.commType === 'email' ) ? (
                                                    <TimelineEmail cid={c.cid} />
                                                ) : (
                                                    ( c.commType === 'sms' ) ? (
                                                        <TimelineSms cid={c.cid} />
                                                    ) : (
                                                        ( c.video ) ? (
                                                            <video src={`https://tf-media.s3.amazonaws.com/${aid}/${c.mediaUrl}`} controls playsInline style={ { width: '400px' } }></video>
                                                        ) : (
                                                            ( c.audio ) ? (
                                                                <audio src={`https://tf-media.s3.amazonaws.com/${aid}/${c.mediaUrl}`} controls playsInline></audio>
                                                            ) : (
                                                                ( c.details ) ? (
                                                                    <span>{c.details}</span>
                                                                ) : (
                                                                    null
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            }
                                        </TimelineEvent>
                                    ) )
                                }
                            </Timeline>
                        </Tab>
                    </Tabs>
                ) : (
                    ( v2 ) ? (
                        view.map( ( v, idx ) => {
                            let show = true;
                            if ( v.conditional ) {
                                console.log( 'cond: ', v.conditional );
                                switch ( v.conditional.operator ) {
                                    case 'valid':
                                        console.log( obj.details[v.conditional.db] );
                                        show = ( obj.details[v.conditional.db] !== undefined );
                                        break;

                                    default:
                                        show = ( obj.details[v.conditional.db] === v.conditional.value );
                                }
                            }
                            if ( show ) {
                                return <SectionV2 key={`section-${idx}`} title={v.title} body={v.body} id={v.id} />;
                            }
                            return null;
                        } )
                    ) : (
                        view.map( ( v, idx ) => (
                            <Section key={`section-${idx}`} title={v.title} body={v.body} />
                        ) )
                    )
                )
            }
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    commsLoaded: state.comms.loaded
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( Details );